(function () {
  'use strict';

  var stickySelector = '[data-seaspray-sticky-atc]';
  var primarySelector = '.product-purchase-form button[type="submit"][data-add-to-cart-text]';
  var fulfilmentSelector = '[data-seaspray-fulfilment]';
  var scheduled = false;

  function primaryButton(stickyBar) {
    var productDetail = stickyBar.closest('.product-detail');
    return productDetail ? productDetail.querySelector(primarySelector) : null;
  }

  function syncStickyBar(stickyBar) {
    var primary = primaryButton(stickyBar);
    var stickyButton = stickyBar.querySelector('[data-seaspray-sticky-atc-button]');
    if (!primary || !stickyButton) return;

    stickyButton.innerHTML = primary.innerHTML;
    stickyButton.disabled = primary.disabled;
    stickyButton.setAttribute('aria-disabled', primary.disabled ? 'true' : 'false');
  }

  function shouldShow(stickyBar) {
    if (!window.matchMedia('(max-width: 767.98px)').matches) return false;

    var primary = primaryButton(stickyBar);
    var productSection = stickyBar.closest('[data-linked-product-section]');
    if (!primary || !productSection) return false;

    var primaryRect = primary.getBoundingClientRect();
    var sectionRect = productSection.getBoundingClientRect();
    var sectionVisible = sectionRect.bottom > 0 && sectionRect.top < window.innerHeight;
    var primaryVisible = primaryRect.bottom > 0 && primaryRect.top < window.innerHeight;
    return sectionVisible && !primaryVisible;
  }

  function updateStickyBars() {
    scheduled = false;
    var anyVisible = false;

    document.querySelectorAll(stickySelector).forEach(function (stickyBar) {
      syncStickyBar(stickyBar);
      var visible = shouldShow(stickyBar);
      stickyBar.classList.toggle('seaspray-sticky-atc--visible', visible);
      anyVisible = anyVisible || visible;
    });

    document.body.classList.toggle('has-seaspray-sticky-atc', anyVisible);
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateStickyBars);
  }

  function initialiseStickyBars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(stickySelector).forEach(function (stickyBar) {
      if (stickyBar.dataset.seasprayStickyInitialised === 'true') return;
      stickyBar.dataset.seasprayStickyInitialised = 'true';

      var primary = primaryButton(stickyBar);
      if (primary && window.MutationObserver) {
        new MutationObserver(scheduleUpdate).observe(primary, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true
        });
      }
    });
    scheduleUpdate();
  }

  function formatPounds(pence) {
    var pounds = Math.max(0, pence) / 100;
    var hasPence = Math.round(pounds * 100) % 100 !== 0;
    return '£' + pounds.toFixed(hasPence ? 2 : 0);
  }

  function updateFulfilmentPanel(panel, cartTotal, productPrice) {
    if (!panel) return;

    var threshold = Number(panel.dataset.freeDeliveryThreshold || 0);
    var headline = panel.querySelector('.product-fulfilment__headline');
    if (!threshold || !headline) return;

    cartTotal = Number(cartTotal || 0);
    productPrice = Number(productPrice || panel.dataset.activeProductPrice || 0);
    panel.dataset.cartTotal = String(cartTotal);
    panel.dataset.activeProductPrice = String(productPrice);

    var qualified = cartTotal >= threshold;
    panel.classList.toggle('product-fulfilment--qualified', qualified);
    panel.classList.toggle('product-fulfilment--pending', !qualified);

    if (qualified) {
      headline.textContent = 'Your basket qualifies for free standard UK delivery';
      return;
    }

    var remainingAfterItem = threshold - (cartTotal + productPrice);
    if (remainingAfterItem > 0) {
      headline.textContent = 'Add this item and spend ';
      var amount = document.createElement('strong');
      amount.textContent = formatPounds(remainingAfterItem);
      headline.appendChild(amount);
      headline.appendChild(document.createTextNode(' more for free standard UK delivery'));
    } else {
      headline.textContent = 'Add this item to qualify for free standard UK delivery';
    }
  }

  function initialiseFulfilmentPanels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(fulfilmentSelector).forEach(function (panel) {
      updateFulfilmentPanel(
        panel,
        panel.dataset.cartTotal,
        panel.dataset.activeProductPrice
      );
    });
  }

  function refreshFulfilmentFromCart() {
    var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    window.fetch(routeRoot + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh delivery status');
      return response.json();
    }).then(function (cart) {
      document.querySelectorAll(fulfilmentSelector).forEach(function (panel) {
        updateFulfilmentPanel(panel, cart.total_price, panel.dataset.activeProductPrice);
      });
    }).catch(function () {
      // The server-rendered message remains available if the cart request fails.
    });
  }

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest('[data-seaspray-sticky-atc-button]');
    if (!stickyButton || stickyButton.disabled) return;

    var stickyBar = stickyButton.closest(stickySelector);
    var primary = stickyBar ? primaryButton(stickyBar) : null;
    if (primary) primary.click();
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('input[name="id"]')) return;

    var variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price === 'undefined') return;

    var productSection = target.closest('[data-linked-product-section]');
    var panel = productSection
      ? productSection.querySelector(fulfilmentSelector)
      : document.querySelector(fulfilmentSelector);
    if (!panel) return;

    updateFulfilmentPanel(panel, panel.dataset.cartTotal, variant.price);
  });

  document.documentElement.addEventListener('theme:cartchanged', refreshFulfilmentFromCart);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseStickyBars(event.target);
    initialiseFulfilmentPanels(event.target);
  });

  document.addEventListener('seaspray:linked-product:load', function () {
    initialiseStickyBars(document);
    initialiseFulfilmentPanels(document);
    refreshFulfilmentFromCart();
  });

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);

  if (window.jQuery) {
    window.jQuery(window).on('cc-variant-updated.seasprayProductExperience', scheduleUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseStickyBars(document);
      initialiseFulfilmentPanels(document);
    });
  } else {
    initialiseStickyBars(document);
    initialiseFulfilmentPanels(document);
  }
})();
